<template>
  <v-flex xs12>
    <v-card>
      <v-card-title class="headline">Waiting Time
      </v-card-title>
      <v-card-subtitle>
        <small v-if="booking.waiting_time_charges">{{booking.waiting_time_charges.waiting_time}} mins &pound;{{(booking.waiting_time_charges.charges/100).toFixed(2)}}</small>
        <small v-if="booking.waiting_time_charges && booking.waiting_time_charges.waiting_time_will_kick_in"> Waiting Time Kicked in after {{booking.waiting_time_charges.waiting_time_will_kick_in}} mins</small>
        <small v-if="booking.waiting_time_charges && booking.waiting_time_charges.waiting_time_will_kick_in"> Total Waiting Times {{booking.waiting_time_charges.waiting_time + booking.waiting_time_charges.waiting_time_will_kick_in}} mins</small>
      </v-card-subtitle>
      <v-card-subtitle class="mt-2">Enter new chargeable waiting time in minutes</v-card-subtitle>
      <v-card-text>
        <v-alert
          border="top"
          color="orange lighten-3"
          dark
          v-if="refundableAmount"
        >
          You may refund &pound; {{(refundableAmount/100).toFixed(2)}} to customer.
        </v-alert>
        <v-alert
          border="top"
          color="red lighten-2"
          dark
          v-if="refundableAmount"
        >
          <p v-if="refundError != null">{{ refundError }}</p>
        </v-alert>
        <v-text-field
          outlined
          dense
          placeholder="Waiting time in minutes i.e. 10"
          v-model="waitingTimeInMinutes"
          label="Waiting Time in minutes"
          type="number"
          :rules="[...integerRules]"
          :step="1"
        ></v-text-field>
        <div class="container">
          <div class="line"></div>
          <span class="or">OR </span>
          <div class="line"></div>
        </div>
        <DateAndTimeInput class="mt-2" :form-data="formData"></DateAndTimeInput>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="resetWaitingTime">Submit</v-btn>
        <v-btn color="grey darken-1" text @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import moment from "moment";
import BookingChangelog from '@/components/booking/Changelog'
import {BookingForm} from '@/components/util/BookingForm'
import DateAndTimeInput from '@/components/widget/input/DateAndTimeInput'
import axios from 'axios'


class DateTimeWrapper {
  constructor(date, time) {
    this.date = date;
    this.time = time;
  }
  
  setDate(newDate) {
    this.date = newDate;
  }
  
  setTime(newTime) {
    this.time = newTime;
  }
}

export default {
  name: "AdjustWaitingTimeBox",
  components: {DateAndTimeInput},
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    booking: Object,
    waitingTime: {
      type: Object,
      default: null
    },
    user: {
      type: Object,
      default: null
    },
    waitingTimeKickInTime: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      refundError: '',
      refundableAmount: '',
      refundReason: 'Waiting time charges refund',
      formData: new DateTimeWrapper(null, null),
      waitingTimeDialog: false,
      changelogDialog: false,
      changelogBooking: null,
      waitingTimeInMinutes: null,
      waitingTime1: null,
      waitingTimeTime: null,
      waitingTimeDate: null,
      waitingTimeMenu: false,
      pickerDate: new Date().toISOString().slice(0, 10),
      pickupTime: new Date(), // Replace with the actual pickup time value
      integerRules: [
        v => Number.isInteger(parseFloat(v)) || "Please enter an integer value",
      ],
      mutuallyExclusiveRule: v =>
        (v === null || v === "") ||
        ((this.waitingTime === null || this.waitingTime === "") &&
          (this.waitingTimeInMinutes === null || this.waitingTimeInMinutes === "")) ||
        "Only one field can be entered at a time",
      afterPickupTimeRule: v =>
        (v === null || v === "") || new Date(v) > this.pickupTime || "Waiting Time must be after Pickup Time",
    }
  },
  computed: {
    isArriveTimeAfterPickupTime() {
      if (!this.isArriveTimeEntered) {
        return true
      }
      return moment(this.booking.pickup_date + " " + this.booking.pickup_time,
        "YYYY-MM-DD HH:mm").isBefore(moment(this.formData.date + " " + this.formData.time, "YYYY-MM-DD HH:mm"))
    },
    isArriveTimeEntered() {
      return this.formData.date && this.formData.time
    },
    newArriveTime() {
      return this.formData.date && this.formData.time ? this.formData.date + ' ' + this.formData.time : null
    },
    bookingId () {
      return this.booking ? this.booking.id : null
    },
  },
  methods: {
  
    confirmRefund (refundableAmount) {
      let refund = (refundableAmount/100).toFixed(2)
      this.$swal.fire({
        title: 'You may refund ' + refund,
        text: "This amount will be refunded to customer",
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: this.$colorsConfig.getUnconfirmedBookingColor(),
        cancelButtonColor: '#e85b5b',
        denyButtonColor: '#3085d6',
        confirmButtonText: 'Yes, confirm it!',
        denyButtonText: `Cancel`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.refundTrip(refund)
        } else if (result.isDenied) {
          this.$emit('close')
        }
      })
    },
  
    closeDialog() {
      this.$emit('close')
    },
    resetWaitingTime() {
      if (this.bookingId) {
        if (this.waitingTimeInMinutes && (this.formData.date || this.formData.time)) {
          this.formData.date = ''
          this.formData.time = ''
        }
        if (!this.waitingTimeInMinutes && (!this.formData.date || !this.formData.time)) {
          this.$snackbar.error('Please enter either waiting time or arrive time')
          return;
        }
        if (!this.isArriveTimeAfterPickupTime) {
          this.$snackbar.error('Booking Arrive time should be after pickup time')
          return;
        }
        let chargeableWaitingTime = 0;
        if (this.booking && this.booking.waiting_time_charges && this.booking.waiting_time_charges.waiting_time_will_kick_in ) {
          console.log('waiting time kickin adding to waiting time' + this.booking.waiting_time_charges.waiting_time_will_kick_in)
          chargeableWaitingTime = parseInt(this.waitingTimeInMinutes) +  parseInt(this.booking.waiting_time_charges.waiting_time_will_kick_in)
        }
        this.$store.dispatch('booking/resetWaitingTime', {bookingId: this.bookingId,
          waitingTimeInMinutes: chargeableWaitingTime,
          waitingTime: this.newArriveTime
        }).then(res => {
          console.log('refundable amount', res)
          if (res.data && res.data.refundable_amount) {
            this.$snackbar.success('Waiting time is reset. You may refund to customer')
            this.refundableAmount = res.data.refundable_amount;
            this.confirmRefund(this.refundableAmount)
          } else
            if (res.data && res.data.error && res.data.error == 'waiting_time_reset_error') {
              this.$snackbar.error(res.data.message)
              this.$emit('close')
              return;
            } else {
              this.$emit('close')
              console.log('reset response', res)
              this.$store.commit('booking/setReloadBooking', true)
              this.$snackbar.success('Waiting time is reset for this booking')
            }
        })
      }
    },
    refundTrip: async function(refundableAmount) {
      console.log("Refunding booking");
    
      this.refundError = null;
    
      if (refundableAmount == null || refundableAmount <= 0) {
        this.refundError = "Please enter an amount more than £0 for the refund";
        return;
      }
    
      if (this.refundReason == null || this.refundReason.length == 0) {
        this.refundError = "Please enter a reason for the refund";
        return;
      }
    
      this.loadingRefund = true;
    
      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/refund?booking_id=${this.booking.id
          }&user_id=${this.user.id}&amount=${Math.round(
            refundableAmount * 100
          )}&reason=${this.refundReason}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );
      
        this.loadingRefund = false;
      
        if (response.data.error == "no_error") {
          this.$swal.fire(
            'Confirmed!',
            'The waiting time charges are refunded',
            'success'
          )
          this.$emit('close')
        } else {
          if (response.data.error == "invalid_refund_amount") {
            this.refundError =
              "Please enter an amount more than £0 for the refund";
          } else if (response.data.error == "invalid_refund_amount_too_large") {
            this.refundError = "Refund amount too large";
          } else {
            this.refundError = response.data.error;
          }
        }
      } catch (error) {
        console.log(error);
        this.refundError = "Unknown Error";
      
      }
    }
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}

tr[role="row"] {
  height: 64px !important;
}

.e-resource-column-wrap tr {
  height: 64px !important;
}

.timeline .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11px !important;
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.line {
  flex-grow: 1;
  height: 1px;
  background-color: #000;
}

.or {
  margin: 0 10px;
}

</style>
